class VariantPropertyAvailability {
  constructor(variantProperty, {isAvailable = false}) {
    this.variantProperty = variantProperty;
    this.isAvailable = isAvailable;
  }

  equals(other) {
    return this.variantProperty.equals(other.variantProperty);
  }

  hashCode() {
    return 0;
  }
}

export default VariantPropertyAvailability;
